<template>
  <Breadcrumbs
      title="Invoices"
      :breadcrumbs="[
      { label: 'Sales', path: '' },
      { label: 'Invoices', path: '/invoice' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <invoiceForm/>
    </div>
  </div>
</template>

<script>
import invoiceForm from './invoiceForm.vue'
export default {
  name: 'indexList',
  components: {
    invoiceForm,
  },
}
</script>
